export const changePasswordModal = {
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		// paddingBottom: '48px',

		'@media (max-width: 640px)': {
			// paddingBottom: '20px',
		},
	},
	fieldWrap: {
		marginBottom: '16px',
	},
	formWrap: {
		width: '100%',
	},
	containedBlue: {
		background: 'var(--primary-500)',
	},
	iconWrap: {
		marginBottom: '32px',
	},
	contentWrap: {
		marginBottom: '16px',
	},
	title: {
		textAlign: 'center',
		marginBottom: '8px',
	},
	description: {
		textAlign: 'center',
		color: 'var(--neutral-300)',
		fontSize: '16px',
	},
	btnWrap: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '16px',
		width: '100%',
	},
	btn: {
		width: '100%',
	},
};
